// The game's languages: English (the source), French and Cameroon Pidgin. t('English text')
// returns the text in the chosen language, or the English when a translation is missing, so a new
// string is never broken, only untranslated. Variables are written {name} in the source and filled
// after translation: t('Taxi home to {place}', { place }).
import { FR } from './lang/fr.js';
import { PCM } from './lang/pcm.js';

export const LANGS = { en: 'English', fr: 'Français', pcm: 'Pidgin' };
const TABLES = { en: null, fr: FR, pcm: PCM };
const KEY = 'abakwa-lang';
let current = 'en';

export function lang() {
  return current;
}

// Picks the language: ?lang=, else what was kept, else the browser's French, else English.
export function setLang(code, remember = true) {
  current = LANGS[code] ? code : 'en';
  if (remember) {
    try {
      localStorage.setItem(KEY, current);
    } catch {
      // not remembered
    }
  }
  if (typeof document !== 'undefined') document.documentElement.lang = current === 'pcm' ? 'en' : current;
  return current;
}

export function startLang(params) {
  const asked = params && params.get('lang');
  if (asked && LANGS[asked]) return setLang(asked, false);
  try {
    const kept = localStorage.getItem(KEY);
    if (kept && LANGS[kept]) return setLang(kept, false);
  } catch {
    // no storage
  }
  const nav = typeof navigator !== 'undefined' ? (navigator.language || '').toLowerCase() : '';
  return setLang(nav.startsWith('fr') ? 'fr' : 'en', false);
}

export function t(text, vars) {
  if (text === null || text === undefined) return text;
  const table = TABLES[current];
  let out = table && Object.hasOwn(table, text) ? table[text] : text;
  if (vars) for (const [k, v] of Object.entries(vars)) out = out.split(`{${k}}`).join(String(v));
  return out;
}

// For tables of lines (what the townspeople say): the language's set, or the English one.
export function pickTable(byLang) {
  return byLang[current] || byLang.en || byLang[Object.keys(byLang)[0]];
}
